import * as ACTION_TYPES from '../constants/ACTION_TYPES';
import * as api from '../api';
import * as C from '../constants';
import * as Selectors from '../reducers/selectors';
import { createAction } from 'redux-actions';
import piwikTracker from '../utils/piwik';
import { getUrlParams } from '../utils/api';
import {
  addDataItemToCart,
  addShopItemToCart,
  addShopItemCategoryToCart,
} from 'actions/ActionCreators';
import { updateIsFetchingCart } from './CartActionCreators';

const RECOMMENDED_QUERY = 'alcohol';
export const beginCatalogSearch = (query: string) => ({
  type: ACTION_TYPES.CATALOG_BEGIN_SEARCH,
  payload: {
    query,
  },
});

export const caughtCatalogSearchError = (e: any): CatalogSearchErrorAction => ({
  type: ACTION_TYPES.CATALOG_SEARCH_ERROR,
  payload: e,
  error: true,
});

export const receivedCatalogSearchResults = createAction(
  ACTION_TYPES.CATALOG_RECEIVED_SEARCH_RESULTS,
  (json: GetCatalogResponse) => ({ ...json })
);

export const resetFocusedItem = () => ({
  type: ACTION_TYPES.CATALOG_RESET_FOCUS,
});

export const toggleFilterShopItem = () => ({
  type: ACTION_TYPES.CATALOG_FILTER_SHOP_ITEM,
});

export const toggleFilterDataItem = () => ({
  type: ACTION_TYPES.CATALOG_FILTER_DATA_ITEM,
});

export const toggleFilterShopItemCategory = () => ({
  type: ACTION_TYPES.CATALOG_FILTER_SHOP_ITEM_CATEGORY,
});

export const setUserInitiateSearch = (isUserSearch: boolean) => ({
  type: ACTION_TYPES.CATALOG_USER_INITIATE_SEARCH,
  payload: isUserSearch,
});

const trackSearchCatalog = (query: string, state: RootState) =>
  piwikTracker.trackSiteSearch(
    query,
    C.ANALYTICS.CATEGORY_CATALOG,
    Selectors.getSearchResultCount(state)
  );

/**
 * If search is initiated by the user, sets `isUserSearch` to true.
 * Otherwise, if initiated by a component, set it to false.
 */
export function searchCatalog(query: string, isUserSearch = true) {
  return async (dispatch: Function, getState: Function) => {
    dispatch(beginCatalogSearch(query));
    dispatch(setUserInitiateSearch(isUserSearch));
    try {
      const { chid } = getUrlParams();
      const payload = { q: query, channel_id: chid };

      const json = await api.catalog.getCatalog(payload);
      dispatch(receivedCatalogSearchResults(json));
      if (isUserSearch) trackSearchCatalog(query, getState());
    } catch (err) {
      dispatch(caughtCatalogSearchError(err));
    }
  };
}

export function sendItemsToCart(
  dataItems: DataItem[] = [],
  shopItems: ShopItem[] = [],
  shopItemCategories: ShopItemCategory[] = []
) {
  return (dispatch: Function) => {
    const response = {
      data_items: dataItems,
      shop_items: shopItems,
      shop_item_categories: shopItemCategories,
    };
    dispatch(receivedCatalogSearchResults(response));
  };
}

export function fetchRecommendedItems() {
  const { chid } = getUrlParams();

  let query;
  if (!chid) {
    query = RECOMMENDED_QUERY;
  }

  return async (dispatch: Function, getState: Function) => {
    dispatch(searchCatalog(query, false));
  };
}

export function fetchItemsToCartById(query: string) {
  return async (dispatch: Function, getState: Function) => {
    dispatch(updateIsFetchingCart(true));
    const json = await api.catalog.getCatalogByIds(query);
    const { data_items, shop_items, shop_item_categories } = json;

    dispatch(receivedCatalogSearchResults(json));
    dispatch(addDataItemToCart(data_items));
    dispatch(addShopItemToCart(shop_items));
    dispatch(addShopItemCategoryToCart(shop_item_categories));
    dispatch(updateIsFetchingCart(false));
  };
}



// WEBPACK FOOTER //
// ./app/actions/CatalogActionCreators.ts